import { Component, OnInit, AfterViewInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-store-stepper',
  templateUrl: './store-stepper.component.html',
  styleUrls: ['./store-stepper.component.css']
})
export class StoreStepperComponent implements OnInit, AfterViewInit {
  public selectedStepIndex: number = 0;
  public loadingStep: boolean = false;
  @Output() clickOnAction = new EventEmitter();
  @Output() stepperValue = new EventEmitter<MatStepper>();
  stepUrl = '';
  public stepperClass: string;
  @ViewChild('stepper') myStepper: MatStepper;
  public steps = [
    {
      key: 0,
      title: 'Address'
    },
    {
      key: 1,
      title: 'Delivery'
    },
    {
      key: 2,
      title: 'Payment'
    }

  ];
  constructor(private router: Router) { }

  ngOnInit() {

  }
  ngAfterViewInit() {
    this.stepperValue.emit(this.myStepper);
  }



  selectionChanged(event: any) {
    this.selectedStepIndex = event.selectedIndex;   
    this.navigate(this.selectedStepIndex);
    // if (event.previouslySelectedIndex > event.selectedIndex) {
    //     this.loadingStep = true;
    //     //Wait 1 sec. before showing the step
    //     setTimeout(() => {
    //         this.navigate();
    //         this.loadingStep = false;
    //     }, 1000);
    // } else {
    //     this.navigate();
    // }
  }

  private navigate(index): void {

    if (index == 0) {
      this.stepUrl = 'store/cutomer-detail';
      this.router.navigate([this.stepUrl]);
    }
    if (index == 1) {
      //this.stepUrl = 'store/payment';
      //this.stepperClass='mat-step-icon mat-step-icon-state-number mat-step-icon-selected';
      this.clickOnAction.emit('save');

    }
    if (index == 2) {
      //this.stepUrl = 'store/payment';
      this.clickOnAction.emit('payment');
    }

  }



}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-store-product/store-stepper/store-stepper.component.ts